import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../../shared/store/selected-entity.feature';
import { FamilleLivrables } from '../models/famille-livrables.model';
import { avecMéthodesFamilleLivrables } from './famille-livrables.methods';
import { avecSélecteursFamilleLivrables } from './famille-livrables.selectors';

export type FamilleLivrablesState = {
  filtre: string;
};

const initialState: FamilleLivrablesState = {
  filtre: '',
};

export const FamilleLivrablesStore = signalStore(
  { providedIn: 'root' },
  withEntities<FamilleLivrables>(),
  withState(initialState),
  withSelectedEntity(),
  avecMéthodesFamilleLivrables(),
  avecSélecteursFamilleLivrables(),
);
